import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Category from './components/Kategorie';
import Type from './components/Typy';
import Model from './components/Modele';
import ListTypeComponent from './components/ListaCzesci';
import SparePartListComponent from './components/SparePartList';
import PartsComponent from './components/Part';
import ItemsComponent from './components/Item';
import { PartsProvider } from './components/PartsContext';
import ImportCSV from './components/ImportCSV';

//... importuj też inne komponenty
function App() {
  return (
        <PartsProvider>

    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Category />} />
          <Route path="/type/:categoryId" element={<Type />} />
         <Route path="/model/:typeId" element={<Model />} />
         <Route path="/list-type/:modelId" element={<ListTypeComponent />} />
         <Route path="/spare-part-list/:listTypeId" element={<SparePartListComponent />} />
         <Route path="/parts/:sparePartListId" element={<PartsComponent />} />
         <Route path="/items/:partId" element={<ItemsComponent />} />
        <Route path="/import-csv" element={<ImportCSV />} />


          {/* Dodaj ścieżki dla innych komponentów */}
        </Routes>
      </div>
    </Router>
      </PartsProvider>

  );
}
export default App;
